import React from 'react';
import '../styles/ErrorDialog.css';

interface ErrorDialogProps {
  title: string;
  message: string;
  onClose: () => void;
}

const ErrorDialog: React.FC<ErrorDialogProps> = ({ title, message, onClose }) => {
  return (
    <div className="error-dialog-overlay" onClick={onClose}>
      <div className="error-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="error-icon">
          <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10"/>
            <line x1="15" y1="9" x2="9" y2="15"/>
            <line x1="9" y1="9" x2="15" y2="15"/>
          </svg>
        </div>
        
        <h2 className="error-title">{title}</h2>
        <p className="error-message">{message}</p>
        
        <div className="error-actions">
          <button className="error-ok-btn" onClick={onClose}>
            Εντάξει
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorDialog;
